import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入 socket.io-client
import io from 'socket.io-client'
// 挂载到 window 上
window.io = io
import './plugins/axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import format from 'date-fns/format'
import './assets/css/base.css'
import '@/assets/css/all.less'
import '@/assets/css/homethree.less'
import '@/style/css/main.less'
import comFun from '@/api/comFun'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
Vue.use(comFun)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.filter('format', function (value, formatStr) {
 
  let time = new Date(value ? value.replace(/-/g, '/') : '')
  return format(time == 'Invalid Date' ? new Date(value) : time, formatStr)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')